module.exports = __webpack_public_path__ + "img/bataille.9230e9d7.png";